// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__WwnmK","wrapper_closeButton":"styles_wrapper_closeButton__yZ5Cz"};